import { render, staticRenderFns } from "./ExcelUploadIframe.vue?vue&type=template&id=fb075eb0&"
import script from "./ExcelUploadIframe.vue?vue&type=script&lang=ts&"
export * from "./ExcelUploadIframe.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports